<template>
  <!-- 评估记录 -->
  <div>
    <el-row>
      <!-- 工具条 -->
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
        <el-form-item label="老人姓名">
          <el-input
            v-model.trim="formInline.oldName"
            placeholder="请输入老人姓名"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="老人身份证">
          <el-input
            v-model.trim="formInline.oldIdCard"
            placeholder="请输入老人身份证"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search" plain
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="warning" icon="el-icon-plus" @click="addOrder" plain
            >添加</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        style="width: 100%"
        :data="tableData"
        :loading="tableLoading"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
      >
        <el-table-column
          prop="oldName"
          label="老人姓名"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="oldIdCard"
          label="身份证号"
          min-width="170"
        ></el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          min-width="80"
        ></el-table-column>
        <el-table-column label="评估类型" width="130">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.cacType"
              placeholder="请选择"
              @change="handleChangeCacType(scope.$index, scope.row)"
              style="width: 120px"
            >
              <el-option value="1" label="初评"></el-option>
              <el-option value="2" label="常规评估"></el-option>
              <el-option value="5" label="及时评估"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="evaluator"
          label="评估员"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="evaluatorSignDate"
          label="评估日期"
          min-width="150"
        ></el-table-column>
        <el-table-column prop="levelCareName" label="评估结果" min-width="150">
        </el-table-column>
        <el-table-column label="评估截图" width="100">
          <template slot-scope="scope">
            <el-button
              style="margin-right: 5px"
              type="success"
              size="mini"
              plain
              @click="showPic(scope.$index, scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              style="margin-right: 5px"
              type="success"
              size="mini"
              plain
              @click="handleEdit(scope.$index, scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, prev, pager, next"
        :total="totalDataNumber"
        :page-size="pageSize"
        align="center"
        class="fenye"
      >
      </el-pagination>
    </el-row>

    <!-- 添加弹出框 -->
    <el-dialog
      :title="operation ? '添加评估记录' : '评估记录'"
      :visible.sync="adddialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
      @close="closeDialogReset"
    >
      <el-form
        :inline="true"
        :model="addPgForm"
        ref="addPgForm"
        :rules="dataFormRules"
        class="demo-form-inline"
        label-width="130px"
      >
        <el-form-item label="评估类型" prop="evaluateType">
          <el-select
            v-model="addPgForm.evaluateType"
            placeholder="请选择"
            style="width: 202px"
            :disabled="!operation"
          >
            <el-option value="1" label="初评"></el-option>
            <el-option value="2" label="常规评估"></el-option>
            <el-option value="5" label="及时评估"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="老人姓名" prop="olderName">
          <el-autocomplete
            v-model.trim="addPgForm.olderName"
            auto-complete="off"
            placeholder="模糊搜索老人姓名"
            :fetch-suggestions="querySearchAsync"
            @select="handleOlderSelect"
            :disabled="!operation"
          >
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="老人编号">
          <el-input v-model="addPgForm.code" disabled readonly></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-input v-model="addPgForm.sex" disabled readonly></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="addPgForm.idcard" disabled readonly></el-input>
        </el-form-item>
        <el-form-item label="评估日期" prop="date">
          <el-date-picker
            v-model="addPgForm.date"
            style="width: 202px"
            type="date"
            value-format="yyyy-MM-dd"
            @change="changeServiceTime"
            placeholder="选择日期"
            :disabled="!operation"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="评估员" prop="checkList">
          <el-input
            v-show="!operation"
            disabled
            readonly
            :value="evaluator"
          ></el-input>
          <!--
            <div v-show="!operation" style="margin-top: 35%;">
              <span>{{ evaluator }}</span>
            </div>
          -->
          <el-checkbox-group
            v-show="operation"
            v-model="addPgForm.checkList"
            style="width: 240px"
          >
            <!--
              <el-checkbox v-for="(evaluate,i) in evaluateList" :label="evaluate.id" :key="i" style="margin-top:10px;">{{evaluate.userName}}</el-checkbox>
            -->
            <!-- 传姓名  传id会有bug -->
            <el-checkbox
              v-for="(evaluate, i) in evaluateList"
              :label="evaluate.userName"
              :key="i"
              style="margin-top: 10px; height: 30px; line-height: 20px"
              >{{ evaluate.userName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="评估结果" prop="cause">
          <el-select
            v-model="addPgForm.cause"
            placeholder="请选择"
            style="height: 40px; width: 202px"
            :disabled="!operation"
            @change="nursingCareChange"
          >
            <!--
              <el-option value="0"
                         label="自理"></el-option>
              <el-option value="1"
                         label="半自理"></el-option>
              <el-option value="3"
                         label="失能"></el-option>
            -->
            <el-option
              v-for="item in selfcareStatusList"
              :key="item.id"
              :label="item.nursingCare"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="admissionpg" style="margin-left: 14%; margin-top: 6px">
          <span style="color: red"></span><span>评估截图</span>
          <!--
            <el-form-item label="评估截图" class="admissionpg" prop="pic" ref="pic">
          -->
          <el-upload
            v-model="addPgForm.pic"
            class="avatar-uploader"
            action="string"
            accept="image/png, image/jpeg"
            list-type="picture-card"
            :file-list="fileList"
            :on-remove="handleRemove"
            :http-request="uploadSectionFile"
            :before-upload="uploadSuccess"
            :limit="11"
            ref="imagePic"
            v-if="operation"
            style="display: inline-block; margin-left: 5px"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="display: flex; flex-wrap: wrap">
            <div v-for="item in fileList" :key="item.url" v-show="!operation">
              <img
                style="width: 60px; height: 60px; margin-right: 4px"
                :src="item.url"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button v-if="operation" @click.native="adddialogVisible = false"
          >取 消</el-button
        >
        <el-button
          v-if="operation"
          type="primary"
          @click.native="submitForm"
          :loading="editLoading"
          >确 定</el-button
        >
        <el-button
          type="primary"
          v-if="!operation"
          @click.native="adddialogVisible = false"
          :loading="editLoading"
          >关闭</el-button
        >
      </div>
    </el-dialog>
    <!-- 图片预览弹出框 -->
    <el-dialog
      title="图片"
      :visible.sync="showPicDialog"
      width="45%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeDialogReset"
    >
      <div style="display: flex; flex-wrap: wrap; justify-content: center">
        <div v-for="(item, index) in fileList" :key="index">
          <el-image
            style="width: 200px; height: 200px; margin-right: 10px"
            class="image"
            fit="fill"
            :src="item.url"
            :preview-src-list="[item.url]"
          ></el-image>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="showPicDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import util from "@/utils/util.js";
export default {
  name: "AdmissionPg",
  data() {
    return {
      formInline: {
        oldName: "",
        oldIdCard: "",
      },
      evaluator: "", //评估员姓名
      isLook: false, //判断是否是查看
      fileList: [], //照片回显
      fileDataList: [],
      operation: true, // true:新增, false:编辑
      avatar: "",
      filePic: "", //图片文件
      picture: "picture", //上传的文件格式
      bucketName: "cmny-oss", //七牛云bucket
      tableData: [], //表格的数据源
      tableLoading: false, //表格加载的loading
      editLoading: false, //确定按钮提交数据按钮  默认为false
      /* 分页的 */
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 0, //数据的总数,
      adddialogVisible: false,
      showPicDialog: false,
      showPicUrl: "", //查看图片的dialog中的图片url
      srcList: [], //查看图片的dialog中图片放大预览
      addPgForm: {
        evaluateType: "1",
        olderName: "",
        oldmanId: "",
        code: "",
        sex: "",
        idcard: "",
        date: util.formatDate.format(new Date(), "yyyy-MM-dd"),
        checkList: [],
        cause: "",
        pic: [],
      }, //添加评估form表单
      evaluateList: [], //评估员的集合
      evaluateType: true, //用来控制表格中的评估类型的状态
      tableCacId: "", //表格的对应行的评估id
      dataFormRules: {
        //正则验证
        evaluateType: [
          { required: true, message: "不能为空", trigger: "change" }, //是否必填 //规则  //何事件触发
        ],
        olderName: [{ required: true, message: "不能为空", trigger: "change" }],
        date: [{ required: true, message: "不能为空", trigger: "change" }],
        checkList: [{ required: true, message: "不能为空", trigger: "change" }],
        cause: [{ required: true, message: "不能为空", trigger: "change" }],
        //pic:[{ required: true, message: "不能为空", trigger: "change" }],
      },
      selfcareStatusList: [], // 护理等级列表
      levelCareName: "", // 护理等级name
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //   获取护理等级列表
    getSelfcareStatusList() {
      let params = {
        pageNum: 1,
        pageSize: 999,
        groupId: Number(sessionStorage.getItem("groupId")),
      };
      this.$postJson("omc/levelCare/select", params).then((res) => {
        if (res.code == 200) {
          this.selfcareStatusList = res.result.list;
        } else {
          this.selfcareStatusList = [];
        }
      });
    },
    formatSelfcareStatus: function (row) {
      var title = "";
      this.selfcareStatusList.forEach((item) => {
        if (item.id == row.finalGrade) {
          title = item.nursingCare;
        }
      });
      return title;
    },
    /* 
      清除校验
    */
    clearValidate(formName) {
      //formName为传入要清除的prop ，可以是整个form表单，也可以是一个
      this.$refs[formName].clearValidate();
    },

    /* 
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        if (
          this.formInline.oldName != null ||
          this.formInline.oldIdCard != null
        ) {
          if (this.formInline.oldName == "") {
            this.queryEvaluateOldman(
              this.formInline.oldName,
              (this.pageNum = 1)
            );
          } else {
            this.queryEvaluateOldman(
              this.formInline.oldName,
              (this.pageNum = 1),
              (this.pageSize = 10)
            );
          }
        }
      }
    },

    /* 
      点击查询
    */
    search() {
      console.log("oldNameoldName"); 
      this.pageNum = 1  
      this.queryEvaluateOldman()
      
      // if (this.formInline.oldName == "") {
      //   this.queryEvaluateOldman(this.formInline.oldName, (this.pageNum = 1));
      // } else {
      //   this.queryEvaluateOldman(
      //     this.formInline.oldName,
      //     (this.pageNum = 1),
      //     (this.pageSize = 10)
      //   );
      // }
    },

    /* 
      关闭新增和修改评估的dialog清除验证
    */
    closeDialogReset() {
      //document.getElementById('uppic').value='';//每次关闭dialog框都清空上传文件file的值，以防再次打开选择相同的不能触发change时间
      //this.filePic=""//清空上传的图片文件
      this.fileList = []; //清空上传的图片文件 by xiang
      this.fileDataList = [];
      if (this.$refs["addPgForm"] != undefined) {
        this.$refs["addPgForm"].resetFields(); //移除校验结果并重置字段值
      }
      this.addPgForm = {
        evaluateType: "1",
        olderName: "",
        oldmanId: "",
        code: "",
        sex: "",
        idcard: "",
        date: util.formatDate.format(new Date(), "yyyy-MM-dd"),
        checkList: [],
        cause: "",
        pic: [],
      };
    },

    /* 
      添加评估 打开dialog模态框
    */
    addOrder() {
      this.isLook = false;
      this.operation = true;
      this.adddialogVisible = true;
    },

    // 显示编辑界面  数据回显
    handleEdit(index, row) {
      this.isLook = true;
      this.adddialogVisible = true;
      this.operation = false;
      let pgObj = new Object();
      pgObj.cacId = row.cacId; //评估id
      pgObj.evaluateType =
        row.cacType == "初评"
          ? "1"
          : row.cacType == "常规评估"
          ? "2"
          : "及时评估";
      pgObj.oldmanId = row.oldmanId;
      pgObj.olderName = row.oldName;
      pgObj.code = row.oldManNo;
      pgObj.sex = row.sex;
      pgObj.idcard = row.oldIdCard;
      pgObj.date = row.evaluatorSignDate;
      (pgObj.cause = row.finalGrade ? String(row.finalGrade) : ""),
        // row.finalGrade == '自理' ? '0' : row.finalGrade == '失能' ? '3' : '1'
        (pgObj.pic = row.videoId);
      pgObj.checkList = [];
      let checkList = row.evaluator.split(",");
      console.log(checkList);
      checkList.forEach((item) => {
        if (item == "") {
          //去除空的字符串
          checkList.splice(index, 1, item);
        } else {
          pgObj.checkList.push(item);
        }
      });
      this.evaluator = checkList.join(";");
      pgObj.cause = row.levelCareName;
      this.addPgForm = Object.assign({}, pgObj);
      //照片回显 by xiang
      let ids = row.videoId.split(",,");
      console.log(row.videoId);
      for (var i = 0; i < ids.length; i++) {
        if (ids[i] != "" && ids[i] != undefined && ids[i] != null) {
          this.fileList.push({  url:ids[i] });
        }
      }
      console.log(this.fileList);
    },

    /* 
      查看图片
    */
    showPic(index, row) {
      this.fileList = []; //每次点击清空
      console.log(index, row);
      this.showPicDialog = true;
      //照片回显 by xiang
      let ids = row.videoId.split(",,");
      for (var i = 0; i < ids.length; i++) {
        if (ids[i] != "" && ids[i] != undefined && ids[i] != null) {
          this.fileList.push({
                  url:ids[i]
                });
        }
      }
      console.log(this.fileList);
    },

    /* 
      查询该机构的评估员
    */
    queryEvaluater() {
      this.$postForm("cac/CacOldman/selectEvaluator").then((res) => {
        console.log(res);
        this.evaluateList = res.result;
        if(res.result == null || res.result.length==0){
          this.evaluateList = [{
            userName:'评估员'
          }]
        }
        console.log(this.evaluateList, "this.evaluateList");
      });
    },

    /* 
    模糊搜索老人 
    */
    querySearchAsync(queryString, cb) {
      //根据 queryString 搜索
      var list = [{}];
      let params = {
        oldName: queryString,
        evaluateType: this.addPgForm.evaluateType,
      };
      console.log(params);
      this.$postJson("cac/CacOldman/selectByName", params).then((res) => {
        if (res.result.length > 0) {
          for (let i of res.result) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.addPgForm.olderName = "";
          }, 1000);
        }
      });
    },

    /* 
      表格下拉框选择评估类型  by guo 2019-09-03 13:40添加
    */
    handleChangeCacType(index, row) {
      console.log(index, row);
      this.queryByOldManId(row.oldmanId, row.cacType);
      this.tableCacId = row.cacId;
      console.log(this.tableCacId);
    },

    /* 
      根据老人ID查询评估状态  by guo 2019-09-03 13:40添加
    */
    queryByOldManId(oldmanId, evaluateType) {
      let params = new Object();
      params.oldManId = oldmanId;
      params.evaluateType = evaluateType;
      console.log(params);
      this.$postForm("cac/CacOldman/queryByOldManId", params).then((res) => {
        console.log(res, "查询评估状态");
        if (res.code == 200) {
          if (res.result != null) {
            this.$message({ message: res.message, type: "success" });
            console.log(this.tableData);
            //改变评估类型 by xiang
            for (var i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].oldmanId == res.result.oldmanId) {
                console.log(res.result);
                if (res.result.cacType == 1) {
                  res.result.cacType = "初评";
                } else if (res.result.cacType == 2) {
                  res.result.cacType = "常规评估";
                } else {
                  res.result.cacType = "及时评估";
                }

                if (res.result.finalGrade == 0) {
                  res.result.finalGrade = "自理";
                } else if (res.result.finalGrade == 3) {
                  res.result.finalGrade = "失能";
                } else {
                  res.result.finalGrade = "半自理";
                }

                if (res.result.sex == 0) {
                  res.result.sex = "男";
                } else {
                  res.result.sex = "女";
                }
                this.$set(this.tableData, i, res.result); //修改当前行的数据  重新注入到this.tableData的数据源中
              }
            }
          } else {
            this.tableData.forEach((item, index) => {
              if (item.cacId == this.tableCacId) {
                //判断点击的是哪一行
                this.$set(item, "cacType", "初评"); //修改当行的
              }
            });
            this.$message({ message: res.message, type: "error" });
          }
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });
    },

    /* 
      搜索老人的下拉框change
    */
    handleOlderSelect(item) {
      console.log(item);
      this.addPgForm.oldmanId = item.oldmanId;
      this.addPgForm.code = item.oldManNo;
      this.addPgForm.sex = item.sex == "0" ? "男" : "女";
      this.addPgForm.idcard = item.oldIdCard;
    },

    /* 
      上传图片 
    */
    uploadSectionFile(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        console.log(form);
        this.$postFormData("dmc/file/uploadFile", form).then((res) => {
          this.addPgForm.pic.push(res.result); //添加图片的id
          if (res.code == 200) {
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      }
    },

    //删除图片
    handleRemove(file, fileList) {
      console.log(file);
      console.log(this.fileDataList);
      for (let i = 0; i < this.fileDataList.length; i++) {
        if (file.uid == this.fileDataList[i].uid) {
          this.fileIndex = i;
          this.fileDataList.splice(i, 1);
        }
      }
      for (let k = 0; k < this.fileList.length; k++) {
        if (file.url == this.fileList[k].url) {
          this.fileIndex = k;
          this.addPgForm.pic.splice(k, 1);
        }
      }
    },

    uploadSuccess(file) {
      this.fileDataList.push(file);
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      console.log(this.fileDataList);
      const limit = this.fileDataList.length <= 10;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      if (!limit) {
        this.$message.error("上传图片最多只能10张！");
        return false;
      }
      return isJPG && isLt2M && limit;
    },

    /* 
      图片的回显
    */
    // getImgInfo(picId){
    //   let id=picId
    //   console.log(id)
    //   if(id){
    //     this.srcList=[];
    //     this.$postForm("opc/file/queryAttachmentById/"+id).then((res)=>{
    //       console.log(res);
    //       var path=res.result.path;
    //       var name=res.result.name;
    //       this.avatar="http://51cs8.com/" + path + name;
    //       this.showPicUrl="http://51cs8.com/" + path + name;
    //       this.srcList.push(this.showPicUrl);
    //     })
    //   }
    // },

    /* 
      评估时间的change事件
    */
    changeServiceTime(val) {
      console.log(val);
    },
    /* 
    评估结果change事件
*/
    nursingCareChange(val) {
      console.log(val);
      this.selfcareStatusList.forEach((item) => {
        if (item.id == val) {
          console.log(item);
          this.levelCareName = item.nursingCare;
        }
      });
    },
    /* 
      评估提交数据
    */
    submitForm() {
      setTimeout(() => {
        this.$refs.addPgForm.validate((valid) => {
          if(this.fileDataList.length == 0){
            this.fileDataList = ['']
          }
          if (this.fileDataList.length > 0) {
            let examinephoto = [];
            for (let i = 0; i < this.addPgForm.pic.length; i++) {
              examinephoto.push(this.addPgForm.pic[i]);
            }
            if(examinephoto.length == 0){
              examinephoto = ['https://img1.baidu.com/it/u=2453767030,1160403397&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500']
            }
            if (valid) {
              if (examinephoto.length > 0) {
                this.editLoading = true;
                var evaluator = ""; //循环之前清空数据，防止累加
                this.addPgForm.checkList.forEach((item) => {
                  evaluator += item + ",";
                });
                evaluator = evaluator.substr(0, evaluator.length - 1);
                console.log(evaluator);
                let params = {};
                (params.cacType = this.addPgForm.evaluateType * 1), //评估类型
                  (params.oldmanId = this.addPgForm.oldmanId); //老人id
                params.evaluatorSignDate = this.addPgForm.date; //评估时间
                params.evaluator = evaluator; //评估员
                params.finalGrade = this.addPgForm.cause; //评估结果
                params.videoId = examinephoto.join(",,"); //文件资源
                params.levelCareId = this.addPgForm.cause;
                params.levelCareName = this.levelCareName;
                if (this.operation == false) {
                  //修改的时候才传评估id
                  params.cacId = this.addPgForm.cacId;
                }
                console.log(this.operation, params);
                //this.operation==true为新增的url  this.operation==false为修改的url
                let url = "";
                this.operation == true
                  ? (url = "cac/CacOldman/addCacOldmanWc")
                  : (url = "cac/CacOldman/updateCacOldman");
                console.log(url);
                this.$postForm(url, params).then((res) => {
                  console.log(res);
                  this.editLoading = false;
                  if (res.code == 200) {
                    this.$message({ message: "操作成功", type: "success" });
                    this.adddialogVisible = false;
                    this.$refs["addPgForm"].resetFields();
                  } else {
                    this.$message({
                      message: "操作失败, " + res.message,
                      type: "error",
                    });
                  }
                  this.queryEvaluateOldman(); //刷新表格的数据
                });
              } else {
                this.$message({ message: "评估截图不能为空", type: "error" });
              }
            }
          } else {
            this.$message({ message: "评估截图不能为空", type: "error" });
          }
        });
      }, 1000);
    },

    /* 
      查询评估老人的分页
    */
    queryEvaluateOldman() {
      let params = {};
      params.oldName = this.formInline.oldName;
      // by yhw 20210701 添加
      params.oldIdCard = this.formInline.oldIdCard;
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableData = []; //请求之前先清空数据
      this.tableLoading = true;
      this.$postJson("cac/CacOldman/showAllWithPage", params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          if (res.result.list != null) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.totalCount * 1;
            //循环遍历处理数据
            res.result.list.forEach((item) => {
              let object = {};
              object = Object.assign({}, item);
              object.sex = item.sex == 0 ? "男" : "女";
              object.cacType = String(item.cacType); //by guo 2019-09-03 13:21 修改  需要转换成字符串类型 否则页面会显示数字
              object.cacType =
                item.cacType == 1
                  ? "初评"
                  : item.cacType == 2
                  ? "常规评估"
                  : "及时评估";
              //   object.finalGrade =
              //     item.finalGrade == 0
              //       ? '自理'
              //       : item.finalGrade == 3
              //       ? '失能'
              //       : '半自理'
              object.finalGrade = item.finalGrade;
              let arr = [];
              // item.evaluator=item.evaluator.substr(0,item.evaluator.length-1);
              arr = item.evaluator.split(",");
              // console.log(arr);
              //by guo 2019-08-30-14:34   添加的时候修改为传评估员的姓名  这里不需要处理数据
              // object.evaluatorName='';
              // console.log(this.evaluateList)
              // this.evaluateList.forEach(temp=>{
              //   arr.forEach(eva=>{
              //     if(eva==temp.id){
              //       object.evaluatorName+=temp.userName+",";
              //     }
              //   })
              // })
              // console.log(object.evaluatorName)
              // object.evaluatorName=object.evaluatorName.substr(0,object.evaluatorName.length-1);//处理评估员的显示
              // console.log(object.evaluatorName)
              this.tableData.push(object);
              // console.log(this.tableData, "------");
            });
          } else {
            this.tableData = [];
            this.totalDataNumber = 0;
          }
        }
        setTimeout(() => {
          this.tableLoading = false;
        }, 1000);
      });
    },

    /* 
      初始页currentPage、初始每页数据数pagesize和数据data
    */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.queryEvaluateOldman(); //刷新套餐列表的数据
    },

    /* 
      当前页变化
    */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.queryEvaluateOldman(); //刷新套餐列表的数据
    },
  },
  created() {
    this.queryEvaluater();
    this.getSelfcareStatusList();
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.queryEvaluateOldman();
      }, 500);
    });
  },
  computed: {},
};
</script>
<style lang="scss" scoped>

.toolbar{
  padding-left: 8px;
  padding-top: 5px;
}
::v-deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
.rz-picter {
  width: 150px;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.rz-picter:hover {
  border-color: #409eff;
}
.img-avatar {
  width: 140px;
  height: 140px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.uppic {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  opacity: 0;
}
.curcor {
  cursor: pointer;
}
.showpicrow {
  width: 100%;
  text-align: center;
}
.image {
  width: 300px;
  height: 300px;
  text-align: center;
  vertical-align: middle;
}
.admissionpg ::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 75px;
  height: 75px;
}
.admissionpg ::v-deep .el-upload--picture-card {
  width: 75px;
  height: 75px;
  line-height: 84px;
}
.demo-form-inline ::v-deep .el-input.is-disabled .el-input__inner {
  color: #606266;
}
.fenye {
  padding: 30px 0;background: #fff;
}
</style>
